import React from 'react';
import { CHECKOUT_URL, modules } from '../data/hvac';
export function ModulesSection() {
  return <section className="bg-off px-4 py-5 sm:py-7" data-id="element-92" data-mp="1nuee9qa20no5">
      <div className="mx-auto max-w-4xl" data-id="element-93" data-mp="1nsl5a4byxrcz">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-3xl" data-id="element-94" data-mp="1iv1sz9ytzono">
          What’s Inside
        </h2>

        <div className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-95" data-mp="1dxjgj9llurax">
          {modules.map(module => <a key={module.num} href={CHECKOUT_URL} className="flex flex-col rounded-lg border border-navy/10 bg-white p-3 shadow-sm transition-colors duration-150 hover:border-hvac" data-id="element-96" data-mp="2bj7fa15j9lpm">
              <p className="text-[11px] font-extrabold uppercase tracking-wide text-service" data-id="element-97" data-mp="21o5ol0vm0bkx">
                ✅ Module {module.num}
              </p>
              <h3 className="mt-0.5 text-base leading-tight text-navy sm:text-lg" data-id="element-98" data-mp="q75wo6d6byrf">
                {module.title}
              </h3>
              {module.body.map(paragraph => <p key={paragraph} className="mt-1 text-sm font-medium leading-snug text-charcoal/80" data-id="element-99" data-mp="1iup9iihi98qz">
                  {paragraph}
                </p>)}
              <p className="mt-auto pt-1.5 text-sm font-extrabold uppercase text-hvac" data-id="element-100" data-mp="18w14qlej6q58">
                {module.kicker}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}